module.exports = __webpack_public_path__ + "87c2da67f0fee18cb67b45bff1ffb65b.glb";